import { lotties } from '@/shared/utils/lotties';
import { lazy } from 'react';

const CachedLottie = lazy(() => import('@/widgets/cached-lottie').then((module) => ({ default: module.CachedLottie })));

export const EnvUnsupported = () => {
  return (
    <div className="flex h-dvh w-full flex-col items-center justify-center gap-y-6 px-2">
      <CachedLottie animationUrl={lotties.xMark} />
      <div className="flex flex-col gap-y-1.5 text-center">
        <h2 className="text-xl leading-6 font-semibold text-balance">Это окружение не поддерживается</h2>
        <p className="text-balance text-black/70">Откройте эту страницу внутри Telegram</p>
      </div>
    </div>
  );
};
